import { Language } from "@/components/I18nProvider"
import { Theme } from "@/components/ThemeProvider"
import authorizedRequest from "@/lib/axios/authorizedRequest"

export interface PushNotificationPref {
  enabled: boolean
}

export interface EmailNotificationPref {
  enabled: boolean
  email: string | null
}

export interface UserPreferencesData {
  language: Language
  theme: Theme
  push_notification?: PushNotificationPref
  email_notification?: EmailNotificationPref
}

export interface UserPreferencesResponse {
  id: string
  user_id: string
  preferences: UserPreferencesData
  created_at: string
  updated_at: string
}

export type UserPreferencesPatch = {
  language?: Language
  theme?: Theme
  push_notification?: Partial<PushNotificationPref>
  email_notification?: Partial<EmailNotificationPref>
}

export async function getUserPreferences(): Promise<{
  status: boolean
  data: UserPreferencesResponse
}> {
  return authorizedRequest.get("/v1/user-preferences") as Promise<{
    status: boolean
    data: UserPreferencesResponse
  }>
}

export async function updateUserPreferences(
  patch: UserPreferencesPatch
): Promise<{ status: boolean; data: UserPreferencesResponse }> {
  return authorizedRequest.patch("/v1/user-preferences", patch) as Promise<{
    status: boolean
    data: UserPreferencesResponse
  }>
}
